varying vec2 vUv; 
uniform sampler2D u_positions;
uniform float u_time;

void main() {
    vec4 newPos = texture2D(u_positions, uv);
    vec4 modelPosition = modelMatrix * vec4(newPos.xyz, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;
    // gl_PointSize = 5.0 * 1.0;
    gl_PointSize = 5.0 * 1.;
    gl_PointSize *= (1.0 / -viewPosition.z);
    vUv = uv; // Ajout de cette ligne pour définir vUv
}
